import list from "./data.js";
import "./Projects.css"
import React from "react";

const Projects = () => {
    return (
        <div className={"projects"} id={"project"}>
            <h1 className={"project-heading"}>
                Projects
            </h1>
            <div className={"row"}>
                {list.map(project => {
                    return <div className={"project-mobile"}>
                        <div className={"project-image"}>
                            <img src={project.image}/>
                        </div>
                        <div className={"mobile-project-detail"}>
                            <h1>{project.projectName}</h1>
                            <p>{project.description}</p>
                            <a href={project.githubUrl} target={"_blank"}>
                                <button className={"github-button"}><i className={"fab fa-github"}></i>Github</button>
                            </a>
                            <a href={project.deploymentUrl} target={"_blank"}>
                                {project.type === "mobile" ?
                                    <button className={"playstore-button"}><i className={"fab fa-google-play"}></i>View
                                        on
                                        play
                                        Store
                                    </button> :
                                    <button className={"playstore-button"}><i className={"fab fa-chrome"}></i>View
                                        deployment
                                    </button>}
                            </a>
                        </div>

                    </div>
                })}
            </div>

        </div>
    );
};


export default Projects;